module.exports = __webpack_public_path__ + "static/img/cjx06.094a76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx06.png
// module id = 55
// module chunks = 0